module.exports = __webpack_public_path__ + "static/media/List.b3e7f9f1.svg";